import { Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject, Subscription } from 'rxjs';
import { Electricity } from '../../../models/electricity.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { fadeInOut } from '../../../services/animations';
import { ElectricityService } from '../../../services/electricity.service';

@Component({
    selector: 'electricity-overview',
    template: require('./electricity-overview.component.html'),
    styles: [require('./electricity-overview.component.css')],
    animations: [fadeInOut]
})
export class ElectricityOverviewComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];
    pagingData: Electricity[] = [];
    currentPage = 1;
    pageSize = 20;
    search = '';
    totalRecords = 0;
    orderByField = 'Date';
    isDesc = false;
    modelChanged = new Subject<string>();

    loading: boolean;

    constructor(private accountService: AccountService, private electricityService: ElectricityService, private ngxLogger: NGXLogger) { }

    ngOnInit() {
        const modelSub = this.modelChanged.debounceTime(500)
            .subscribe(() => {
                this.initializeDataListByPage(1);
            });
        this.subscribers.push(modelSub);
        this.initializeDataListByPage(1);
    }

    initializeDataListByPage(page: number) {
        this.loading = true;
        this.currentPage = page;
        const dataListByPageSub = this.electricityService.getDataListByPage(page, this.pageSize, this.orderByField, this.isDesc, this.search)
            .subscribe((data: any) => {
                if (data && data.Item1) {
                    this.pagingData = data.Item1;
                    this.totalRecords = data.Item2;
                } else {
                    this.pagingData = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.error(err);
                this.ngxLogger.error(err.message);
            });
        this.subscribers.push(dataListByPageSub);
    }

    globalSearch() {
        this.modelChanged.next();
    }

    paginate(event: any) {
        this.pageSize = event.rows;
        this.initializeDataListByPage(event.page + 1);
    }

    customSort(event: any) {
        let isDesc: boolean;
        if (event.order === -1) {
            isDesc = true;
        } else {
            isDesc = false;
        }
        if (event.field !== this.orderByField || isDesc !== this.isDesc) {
            this.orderByField = event.field;
            this.isDesc = isDesc;
            this.initializeDataListByPage(this.currentPage);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    get canelectricityOverviewPermission() {
        return this.accountService.userHasPermission(Permission.electricityOverviewPermission);
    }

    get canelectricityExportPermission() {
        return this.accountService.userHasPermission(Permission.electricityExportPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/electricity/electricity-overview/electricity-overview.component.ts